import { useStaticQuery, graphql } from 'gatsby'

export const useAgendaCategory = id => {
  const { allWordpressWpAgendaCategory } = useStaticQuery(
    graphql`
      query {
        allWordpressWpAgendaCategory {
          edges {
            node {
              wordpress_id
              name
              slug
            }
          }
        }
      }
    `
  )
  return allWordpressWpAgendaCategory.edges.find(
    item => item.node.wordpress_id == id
  )
}
